module.exports = __webpack_public_path__ + "media/images/qr_about-a95144ff49601fe850b400df357ac666.png";